import LinearProgress from '@material-ui/core/LinearProgress'
import { Theme, withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import i18n from 'i18next'
import { withTranslation } from 'react-i18next'
import { reduxForm } from 'redux-form'
import SubmitFormButton from '../../../components/Buttons/SubmitFormButton'
import { ReduxFormField } from '../../../components/FormInput/ReduxWrappers'
import { MuiClasses } from '../../../types'
import {
  validatePassword,
  //  passwordsMatch,
  required
} from '../../../utils/validation/forms'
import FieldContainer from '../../Apartment/FieldContainer'

const styles = (theme: Theme) => ({
  button: {
    marginTop: theme.spacing(2)
  },
  leftIcon: {
    marginRight: theme.spacing()
  },
  outlinedActionButton: {
    border: '1px solid #C4C4C4',
    backgroundColor: '#94004A',
    color: '#FFFFFF',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.12)',
    padding: '7px',
    '&:hover': {
      backgroundColor: '#670033',
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.12)'
    }
  }
})

type ChangePasswordFormProps = {
  classes: MuiClasses
  handleSubmit: (arg: any) => any
  submitting: boolean
  changePassword: (arg: any) => void
  error: string
  t: i18n.TFunction
}

const ChangePasswordForm = ({
  handleSubmit,
  submitting,
  changePassword,
  error,
  t,
  classes
}: ChangePasswordFormProps) => (
  <form onSubmit={handleSubmit(changePassword)}>
    <FieldContainer>
      <ReduxFormField
        name='currentPassword'
        label={t('changePw.currentPassword')}
        type='password'
        autoComplete='on'
        validate={[required]}
        required
      />
    </FieldContainer>
    <FieldContainer>
      <ReduxFormField
        name='password'
        label={t('changePw.password')}
        type='password'
        autoComplete='off'
        helperText={t('changePw.helperText')}
        validate={[required, validatePassword]}
        required
      />
    </FieldContainer>
    {/* <FieldContainer>
      <ReduxFormField
        name='confirmPassword'
        label={t('changePw.confirm')}
        type='password'
        autoComplete='off'
        validate={[required, validatePassword, passwordsMatch]}
        required
      />
    </FieldContainer> */}
    {error && (
      <Typography style={{ color: 'red' }} variant='body1'>
        {error}
      </Typography>
    )}
    <SubmitFormButton
      submitting={submitting}
      label='changePw.change'
      fullWidth
      borderRadius='4px'
      customClasses={classes.outlinedActionButton}
      textColor='#FFFFFF'
      backgroundColor='#94004A'
    />
    {submitting && <LinearProgress />}
  </form>
)

export default reduxForm({
  form: 'ChangePasswordForm'
})(
  withStyles(styles)(withTranslation()(ChangePasswordForm as any)) as any
) as any
